import type {TextBlockSlice} from 'prismicio-types'
import {memo} from 'react'
import type {Context} from 'src/common/types'
import {TextBlockDefault} from './DefaultVariation'
import {TextBlockV2} from './TextBlockV2'
import {TextBlockV3} from './TextBlockV3'

const TextBlock = (props: {slice: TextBlockSlice; context: Context}) => {
  switch (props.slice.variation) {
    case 'default':
      return <TextBlockDefault slice={props.slice} context={props.context} />
    case 'v2':
      return <TextBlockV2 slice={props.slice} />
    case 'v3':
      return <TextBlockV3 slice={props.slice} />
    default:
      return null
  }
}

export default memo(TextBlock)
